import _ from "lodash";
import FilterValue from "./FilterValue";

export default class Filter {
  column;
  values;

  constructor(column, products, columnIdToValuesLowerCase) {
    var other = _.omit(columnIdToValuesLowerCase, column.id);

    var productValuePairs = products.map(product => product.cells[column.id].set.map(value => ({ product: product, value: value })));
    var productValuePairsFlat = _.flatten(productValuePairs);
    var valueToProducts = _.groupBy(productValuePairsFlat, x => x.value.toLowerCase());

    var groups = Object.keys(valueToProducts).map(key => {
      var value = valueToProducts[key][0].value;
      var allProducts = valueToProducts[key].map(a => a.product);
      var filteredProducts = allProducts.filter(product => product.filter(other));

      return {
        value: value,
        allProducts: allProducts,
        filteredProducts: filteredProducts
      };
    });

    var values = groups
      .filter(g => g.filteredProducts.length > 0)
      .sort((a, b) => a.value.localeCompare(b.value, "en", { numeric: true }))
      .map(g => new FilterValue(g.value, g.filteredProducts));

    this.column = column;
    this.values = values;
  }
}
